(() => {
 'use strict';
 function init(){
  for(const mode of ['charge','sign','flags','catalog'])window['STBInit_'+mode]?.();
  const contextEl=document.querySelector('[data-stb-product-context]');
  const variantSelect=document.querySelector('[data-stb-variant]');
  if(variantSelect&&!variantSelect.dataset.ready){variantSelect.dataset.ready='true';variantSelect.addEventListener('change',()=>{
   const data=contextEl?STBCommerce.context()?.product:null;
   let variant=data?.variants?.find(v=>String(v.id)===variantSelect.value);
   const btn=document.querySelector('[data-standard-add]');if(btn){btn.disabled=!variant?.available;btn.textContent=btn.disabled?'Sold out':'Add to Cart';}
   if(variant){const priceNode=document.querySelector('[data-product-price]');if(priceNode)priceNode.textContent=STBCommerce.money(variant.price);}
   const idInput=document.querySelector('[data-form-variant]');if(idInput)idInput.value=variantSelect.value;
   const url=new URL(location.href);url.searchParams.set('variant',variantSelect.value);history.replaceState(null,'',url);
   document.dispatchEvent(new CustomEvent('stb:variant-change',{detail:{variant}}));
  });}
  document.querySelectorAll('[data-gallery-src]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='true';button.addEventListener('click',()=>{const image=button.closest('.stb-product-gallery').querySelector(':scope > img');if(image){image.src=button.dataset.gallerySrc;image.removeAttribute('srcset');}});});
  const quote=document.querySelector('[data-quote-body]');
  if(quote&&!quote.value){try{const saved=sessionStorage.getItem('stbQuoteDetails');if(saved)quote.value=saved;}catch{}}
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
